export const updateMetaTag = () => {
  if (process.env.NODE_ENV !== "production") {
    document.querySelector('meta[name="robots"]')?.remove(); // Remove if exists
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
};
